import React, { useEffect, ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { setTab } from 'components/NavBar/productFormTabs';
import { fetchProductionSites, resetProductionSites } from 'features/Sites/sites';
import { fetchComponents, resetComponentsList } from 'features/ProductComponents/components';
import { resetSerialNumbersList } from 'features/SerialNumbers/serialNumbers';
import { resetProduct, fetchProduct } from './productForm';

const ProductFormWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { productId } = useParams<{ productId: string }>();

  useEffect(() => {
    if (productId) {
      dispatch(fetchProduct({ history, productId }));
      dispatch(fetchComponents({ productId, getAvailableItems: true }));
      dispatch(fetchProductionSites(null));
    }
  }, [dispatch, productId, history]);

  useEffect(() => {
    return () => {
      dispatch(setTab(0));
      dispatch(resetProduct());
      dispatch(resetProductionSites());
      dispatch(resetComponentsList());
      dispatch(resetSerialNumbersList());
    };
  }, [dispatch]);

  return <>{children}</>;
};
export { ProductFormWrapper };
